import React from "react";
import "./BusinessServicesCard.scss";
import { NavLink } from "react-router-dom";

/*
  Вся карточка — одна ссылка. Раньше внутри NavLink лежал ещё один <a>
  («Решение Wi-Fi»), на что React ругался: <a> внутри <a>.
  Внешние адреса открываем обычным <a> с target, внутренние — NavLink,
  якоря на этой же странице — тоже обычной ссылкой.
*/
const BusinessServicesCard = ({ img, title, text, link }) => {
  const content = (
    <>
      <div className="businessServicesCard_item">
        <h3>{title}</h3>
        <p>{text}</p>
        <span className="businessServicesCard_more">
          Подробнее <span aria-hidden="true">→</span>
        </span>
      </div>
      <img src={img} alt="" />
    </>
  );

  const className = "businessServicesCard_link";
  const isExternal = /^https?:/i.test(link || "");
  const isHash = String(link || "").startsWith("#");

  if (isExternal) {
    return (
      <a className={className} href={link} target="_blank" rel="noreferrer">
        {content}
      </a>
    );
  }

  if (isHash) {
    return (
      <a className={className} href={link}>
        {content}
      </a>
    );
  }

  return (
    <NavLink className={className} to={link || "#form"}>
      {content}
    </NavLink>
  );
};

export default BusinessServicesCard;
